import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { ServerResponse } from "../models/server-response.model";
import {catchError} from "rxjs/operators";
import { throwError } from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // headers: HttpHeaders = new HttpHeaders();

  // requestOptions: any;

  constructor(private http: HttpClient) {
    // if (this.aclHelperService.getToken())
    //   this.headers = this.headers.append( 'Authorization', `Bearer ${this.aclHelperService.getToken()}`);
    // this.requestOptions = {  headers: this.headers};
  }


  public get(route: string): Observable<any> {
    const fullUrl = route;
    return this.http.get<ServerResponse>(fullUrl).pipe(
      catchError((error) => {
        console.error('GET request failed:', error);
        return throwError(error);
      })
    );
  }

  public getFileFormServer(url: any): Observable<any> {
    return this.http.get(url ,   { responseType: 'blob', observe: 'response' });
  }

  public post(route: any, data: any): Observable<any> {
    return this.http.post<ServerResponse>(route, data);
  }

  public update(route: any, data: any): Observable<any> {
    return this.http.put<ServerResponse>(route, data);
  }

  public delete(route: any): Observable<any> {
    return this.http.delete<ServerResponse>(route);
  }

  public put(route: any, data: any): Observable<any> {
    return this.http.put<ServerResponse>(route, data);
  }
}
